import { IPromise } from 'angular';
import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../../commonInfra/components/FormikCheckbox';
import { openReactConfirmationDialog } from '../../../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../../../commonInfra/dialogs/style/TabDialogWidth';
import { toNativePromise } from '../../../../../commonInfra/utils/QUtils';
import { getSessionManagementServiceInstance } from '../../../../../sessionManagement/SessionManagementService';
import { FeatureFlags } from '../../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { SiteSettingsForServerAdminProps } from '../../site-settings/ReactSiteSettingsForServerAdmin';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';

export type DataAccelerationSectionProps = SiteSettingsForServerAdminProps<'dataAccelerationEnabled'>;

export function DataAccelerationSection() {
  if (!FeatureFlags.workbookAccelerationUIEnabled || !getSessionManagementServiceInstance().isSessionServerAdmin()) {
    return null;
  }

  return (
    <SettingsSection title={Messages.dataAcceleration()} description={renderCustomDescriptionComponent()} >
      <FormikCheckbox
        name='settings.dataAccelerationEnabled'
        label={Messages.dataAccelerationSiteSettingEnable()}
        testId={'data-acceleration-enable'}
        beforeChange={openConfirmationDialogOnChange}
      />
    </SettingsSection>
  );
}

/*
 * Following the confirmationDialog pattern, this returns a resolved promise
 * if the user confirms the action and rejects the promise if they cancel.
 */
function openConfirmationDialogOnChange(event: React.ChangeEvent<HTMLInputElement>) {
  // Value included with event is the current string value of the checkbox
  const isDataAccelerationEnabled = event.target.value === 'true';
  const dialogPromiseResult: IPromise<unknown> = openReactConfirmationDialog({
    title: isDataAccelerationEnabled
      ? Messages.disableAcceleration()
      : Messages.enableAcceleration(),
    message: isDataAccelerationEnabled
      ? Messages.disableAccelerationConfirmationMsg()
      : Messages.enableAccelerationConfirmationMsg(),
    actionName: Messages.yes(),
    action: () => Promise.resolve(),
    dialogWidth: TabDialogWidth.width375px,
    paramsForAction: null,
  }).result;
  return toNativePromise(dialogPromiseResult);
}

function renderCustomDescriptionComponent() {
  return (
    <>
      <p>{Messages.dataAccelerationSiteSettingMessage()}</p>
      <p>{Messages.dataAccelerationSiteSettingPermissionMsg()}</p>
    </>
  );
}

/* For registering the component in settings registry */
export const DataAccelerationSpecs = componentRegistryEntry({
  name: 'DataAccelerationSection',
  component: DataAccelerationSection
});

